/*
 * Copyright (c) 2018 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
 *
 *Description:
*/
export var ARIA_LIVE_ADD_POLITE_MESSAGE = 'ARIA_LIVE_ADD_POLITE_MESSAGE';
export var ARIA_LIVE_ADD_ASSERTIVE_MESSAGE = 'ARIA_LIVE_ADD_ASSERTIVE_MESSAGE';
export var ARIA_LIVE_ADD_ALERT_MESSAGE = 'ARIA_LIVE_ADD_ALERT_MESSAGE';
export var ARIA_LIVE_REMOVE_POLITE_MESSAGE = 'ARIA_LIVE_REMOVE_POLITE_MESSAGE';
export var ARIA_LIVE_REMOVE_ASSERTIVE_MESSAGE = 'ARIA_LIVE_REMOVE_ASSERTIVE_MESSAGE';
export var ARIA_LIVE_REMOVE_ALERT_MESSAGE = 'ARIA_LIVE_REMOVE_ALERT_MESSAGE';
export var addAriaLivePoliteMessage = function addAriaLivePoliteMessage(payload) {
  return {
    type: ARIA_LIVE_ADD_POLITE_MESSAGE,
    payload: payload
  };
};
export var addAriaLiveAssertiveMessage = function addAriaLiveAssertiveMessage(payload) {
  return {
    type: ARIA_LIVE_ADD_ASSERTIVE_MESSAGE,
    payload: payload
  };
};
export var addAriaLiveAlertMessage = function addAriaLiveAlertMessage(payload) {
  return {
    type: ARIA_LIVE_ADD_ALERT_MESSAGE,
    payload: payload
  };
};
export var removeAriaLivePoliteMessage = function removeAriaLivePoliteMessage(payload) {
  return {
    type: ARIA_LIVE_REMOVE_POLITE_MESSAGE,
    payload: payload
  };
};
export var removeAriaLiveAssertiveMessage = function removeAriaLiveAssertiveMessage(payload) {
  return {
    type: ARIA_LIVE_REMOVE_ASSERTIVE_MESSAGE,
    payload: payload
  };
};
export var removeAriaLiveAlertMessage = function removeAriaLiveAlertMessage(payload) {
  return {
    type: ARIA_LIVE_REMOVE_ALERT_MESSAGE,
    payload: payload
  };
};